import type { QueryClient } from "@tanstack/react-query";

export const invalidateKeyPrefix = (queryClient: QueryClient, prefix: string) =>
    queryClient.invalidateQueries({
        predicate: (query) =>
            typeof query.queryKey[0] === "string" &&
            query.queryKey[0].startsWith(prefix),
    });

export const EMISSIONS_TABLE_PREFIX = "main-emissions-table";
export const UNMATCHED_TABLE_PREFIX = "unmatched-datapoints-table";
export const EPA_TABLE_PREFIX = "epaSep-";

// Site page tables register themselves as `site-<siteId>-emissions`, so they
// aren't covered by EMISSIONS_TABLE_PREFIX.
const SITE_EMISSIONS_TABLE_KEY = /^site-.+-emissions$/;

/**
 * Invalidates the emission data shown on a site page: the emission and
 * non-detect tables plus the timeline's emission counts.
 */
export const invalidateSiteEmissions = (queryClient: QueryClient) =>
    Promise.all([
        queryClient.invalidateQueries({
            predicate: (query) =>
                typeof query.queryKey[0] === "string" &&
                SITE_EMISSIONS_TABLE_KEY.test(query.queryKey[0]),
        }),
        queryClient.invalidateQueries({ queryKey: ["datesWithEmissions"] }),
    ]);
